import React from 'react';
import {FilmIcon, ZapIcon} from '../Icons';

const features = [
  {
    Icon: ZapIcon,
    title: 'AI Transcription',
    description: 'Automatically transcribe video and audio using advanced AI speech recognition.',
  },
  {
    Icon: FilmIcon,
    title: 'Multi-Editor Support',
    description: 'Compatible with Adobe Premiere Pro, DaVinci Resolve, and Final Cut Pro.',
  },
];

// Fades every edge of the clip out to nothing so it dissolves into the section rather than
// sitting in a frame. Two mask layers intersected: one vertical, one horizontal.
const EDGE_FADE = [
  'linear-gradient(to bottom, transparent, #000 0%, #000 95%, transparent)',
  'linear-gradient(to right, transparent, #000 12%, #000 88%, transparent)',
].join(', ');

const Features: React.FC = () => {
  return (
    <section id="features" className="py-20 bg-gray-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white sm:text-4xl">
                        Streamlined audio post-production
          </h2>
          <p className="mt-4 text-lg text-gray-400">
                        From raw audio to censored final cut in minutes
          </p>
        </div>

        {/*
          The clip is pre-cropped to the Premiere timeline panel itself. The source recording is
          letterboxed 1080p with the panel floating in black; cropping that away in the encode
          rather than with `object-position` is most of why the file is 206 KB. EDGE_FADE then
          dissolves all four sides into the background so there is no frame to notice.
          Muted/loop/playsInline are what let it autoplay at all, and `motion-reduce:hidden` drops
          it for anyone who has asked for less movement.
        */}
        <video
          className="mt-12 block h-32 w-full object-cover opacity-90 sm:h-40 lg:h-48 motion-reduce:hidden"
          style={{
            maskImage: EDGE_FADE,
            WebkitMaskImage: EDGE_FADE,
            maskComposite: 'intersect',
            WebkitMaskComposite: 'source-in',
          }}
          src="/censorme-timeline-strip-fancy.mp4"
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
          tabIndex={-1}
        />
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:grid-cols-2">
          {features.map(({Icon, title, description}) => (
            <div key={title} className="text-center">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-lg bg-primary-900 bg-opacity-50">
                <Icon className="h-8 w-8 text-primary-400" />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-white">{title}</h3>
              <p className="mt-2 text-gray-400">{description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Features;
